import api, { apiSuccessOutput } from '@/shared/config/api.js';

// Get all folders
export const getFolders = async (page = 1, size = 10, name) => {
  return apiSuccessOutput(
    await api.get('/dashboard/v1/folders', {
      params: { page, size, name },
      showToast: false,
    }),
  );
};

// Create Folder
export const createFolders = async (name) => {
  return apiSuccessOutput(
    await api.post('/dashboard/v1/folders', {
      name,
    }),
  );
};

// Update Folder
export const updateFolders = async (folder_id, name) => {
  return apiSuccessOutput(
    await api.put(`/dashboard/v1/folders/${folder_id}`, {
      name,
    }),
  );
};

// Delete Folder
export const deleteFolders = async (folder_id) => {
  return apiSuccessOutput(
    await api.delete(`/dashboard/v1/folders/${folder_id}`),
  );
};

// Get all dashboard of folder
export const getDashboard = async (folder_id, name, page = 1, size = 10) => {
  return apiSuccessOutput(
    await api.get('/dashboard/v1', {
      params: {
        page,
        size,
        folder_id,
        name,
      },
      showToast: false,
    }),
  );
};

// Get Detail of dashboard
export const getDetailDashboard = async (dashboard_id) => {
  return apiSuccessOutput(
    await api.get(`/dashboard/v1/${dashboard_id}`, {
      showToast: false,
    }),
  );
};

export const getDashboardsByDevice = async (deviceEui) => {
  return apiSuccessOutput(
    await api.get(`/dashboard/v1/by-device/${encodeURIComponent(deviceEui)}`, {
      showToast: false,
    }),
  );
};

// Update Dashboard
export const updateDashboard = async (dashboard_id, folder_id, name) => {
  return apiSuccessOutput(
    await api.put(`/dashboard/v1/${dashboard_id}`, {
      folder_id,
      name,
    }),
  );
};
